import { FilterOperator } from '@neos/core'

/**
 * Module filter operator from core filter operator.
 * 
 * @param filterOperator Filter operator.
 */
export function typeEquivalenceModuleFilterOperatorFromCoreFilterOperator(filterOperator: (string | null | undefined)): (string | null | undefined) {
  if (filterOperator == FilterOperator.contains.toString()) {
    return 'Contains';
  }
  if (filterOperator == FilterOperator.equal.toString()) {
    return 'Equal';
  }
  if (filterOperator == FilterOperator.notEqual.toString()) {
    return 'NotEqual';
  }
  if (filterOperator == FilterOperator.greater.toString()) {
    return 'Greater';
  }
  if (filterOperator == FilterOperator.less.toString()) {
    return 'Less';
  }
  if (filterOperator == FilterOperator.greaterOrEqual.toString()) {
    return 'GreaterOrEqual';
  }
  if (filterOperator == FilterOperator.lessOrEqual.toString()) {
    return 'LessOrEqual';
  }
  if (filterOperator == FilterOperator.in.toString()) {
    return 'In';
  }
  if (filterOperator == FilterOperator.notIn.toString()) {
    return 'NotIn';
  }
  if (filterOperator == FilterOperator.isNotNull.toString()) {
    return 'IsNotNull';
  }
  if (filterOperator == FilterOperator.isNull.toString()) {
    return 'IsNull';
  }
  if (filterOperator == FilterOperator.between.toString()) {
    return 'Between';
  }
  if (filterOperator == FilterOperator.startsWith.toString()) {
    return 'StartsWith';
  }
  if (filterOperator == FilterOperator.endsWith.toString()) {
    return 'EndsWith';
  }
  return filterOperator;
}
